import { Cell, Grid } from 'bold-ui'
import { CheckboxField, Form, FormDebouncedValueSpy, TextField } from 'components/form'
import { FormState } from 'final-form'
import { CbosQueryInput } from 'graphql/types.generated'
import React from 'react'
import { FormRenderProps } from 'react-final-form'

export interface CboTableFilterProps {
  initialValues?: CbosQueryInput
  onChange(values: CbosQueryInput): void
}

export class CboTableFilter extends React.Component<CboTableFilterProps> {
  render() {
    return (
      <Form<CbosQueryInput>
        onSubmit={this.props.onChange}
        render={this.renderForm}
        initialValues={this.props.initialValues}
      />
    )
  }

  private handleChange = (formState: FormState<CbosQueryInput>) => {
    this.props.onChange(formState.values)
  }

  private renderForm = (props: FormRenderProps<CbosQueryInput>) => {
    return (
      <>
        <FormDebouncedValueSpy onChange={this.handleChange} />

        <Grid alignItems='center' gap={1}>
          <Cell size={4} data-cy={CboTableFilter.name + '.campoPesquisa'}>
            <TextField name='query' placeholder='Pesquise pelo nome ou código' icon='zoomOutline' />
          </Cell>
          <Cell data-cy={CboTableFilter.name + '.mostrarIndisponivelLotacao'}>
            <CheckboxField name='mostrarIndisponivelLotacao' label='Mostrar CBOs indisponíveis para lotação' />
          </Cell>
        </Grid>
      </>
    )
  }
}
